import { useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';

export const useScanToPayNavigation = (closeModal: () => void) => {
  const navigation = useNavigation();

  const goToSgRewards = useCallback(() => {
    closeModal();
    navigation.navigate('MainTabs', {
      screen: 'LoyaltyTab',
      params: {
        screen: 'LoyaltyHome',
      },
    });
  }, [navigation, closeModal]);

  const goToForgotToScan = useCallback(() => {
    closeModal();
    navigation.navigate('MainTabs', {
      screen: 'HomeTab',
      params: {
        screen: 'Home',
      },
    });
  }, [navigation, closeModal]);

  const goToSupport = useCallback(() => {
    closeModal();
    navigation.navigate('Modal', {
      screen: 'Chat',
    });
  }, [navigation, closeModal]);

  const goBack = useCallback(() => {
    closeModal();
    navigation.goBack();
  }, [navigation, closeModal]);

  return {
    goToSgRewards,
    goToForgotToScan,
    goToSupport,
    goBack,
  };
};
